import { remove } from "app/utils/axios/kheti";

const withdrawRequest = async (id: number, role_type: string) => {
  try {
    const url = `/approvals/v1/change/requests/${id}?role_type=${encodeURIComponent(role_type)}`;
    const response = await remove<void>(url); 
    return response;
  } catch (e) {
    console.log("Error withdrawing request:", e);
    return null;
  }
};

export default withdrawRequest;
